import React from 'react';
import LoadLogo from '../../assets/svg/LoadLogo';
import PropTypes from 'prop-types';

import styles from './loading.css';

const Loading = ({ progress }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.bg} style={{ width: `${progress}%` }} />
      <div className={styles.wordMark}>
        <LoadLogo />
      </div>
    </div>
  );
};

Loading.propTypes = {
  progress: PropTypes.number,
};

export default Loading;
